import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';
import WarehouseModal from 'components/Modal/WareHouseModal';

import { TableColumn } from 'components/NewTable/type';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';

import { userTypeList, localeTw, isType } from 'main_consts';
import { Iobject, Ioption } from 'main_type';
import { blobDownload, postExcel, postSearch, snackBarRsp } from 'main_api';

import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Header from 'components/Header';
import {
  formatDate,
  getDateDayPlus,
  getEhuFunctionChk,
  getFindDropDownList,
  getWarehouse,
  initWhrehhouse,
  selectChange,
} from '../../../main_func';
import Select from '../../../components/Material/Select';

import { Iresult, Imaster } from './type';

/** 拆櫃預定表查詢 */
const DevaningPlanQry = (): JSX.Element => {
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'devaningPlanQry';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [warehouseName, setWarehouseName] = useState('');

  const masterDefaultValue: Imaster = {
    // 貨棧業者
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',
    // 拆櫃日期
    declDate: getDateDayPlus(),
    // 線別
    lineNo: '',
    declDateValid: true,
  };
  const [master, setMaster] = useState(masterDefaultValue);

  const [lineNoOptions, setLineNoOptions] = useState<Ioption[]>([]);
  const [chkCode1Show, setChkCode1Show] = useState(false);

  useEffect(() => {
    getFindDropDownList('findDropDownLineNo', {
      warehouse: locationCode,
    }).then((item) => {
      setLineNoOptions(item);
    });
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.topType, userType) ||
        isType(userTypeList.type1, userType) ||
        isType(userTypeList.type2, userType) ||
        isType(userTypeList.type4, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    if (userType) {
      if (isType(userTypeList.type2, userType)) {
        setChkCode1Show(true);
      } else {
        setChkCode1Show(false);
      }
    }
    setMaster((prev) => ({
      ...prev,
      declDate: masterDefaultValue.declDate,
      warehouse: masterDefaultValue.warehouse,
    }));
  }, [userType]);

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postSearch(apiName, {
      warehouse: master.warehouse,
      declDate: master.declDate,
      lineNo: master.lineNo,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    // TODO 確認List名稱
    const rptNmNdLogList = result.data.data as Iresult[];

    if (rptNmNdLogList && (rptNmNdLogList || []).length > 0) {
      setRowData(rptNmNdLogList);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postExcel(apiName, {
      warehouse: master.warehouse,
      declDate: master.declDate,
      lineNo: master.lineNo,
    });

    blobDownload(
      result,
      enqueueSnackbar,
      `${formatDate(master.declDate, 'yyyyMM')}_${
        master.warehouse
      }_拆櫃預定表.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };
  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.declDate.length === 0) {
      master.declDate = getDateDayPlus();
    }
    if (!master.declDateValid) {
      return;
    }

    if (master.declDate.length === 0) {
      master.declDate = getDateDayPlus();
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      if (warehouse.length && warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      setFormError(warehouseResult.error);
    }
  };

  const gridRef = useRef<any>(undefined);
  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        checkboxSelection: false,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '通關日期',
        field: 'declDate',
        width: 300,
      },
      {
        headerName: '船隻掛號',
        field: 'vesselRegNo',
        width: 300,
      },
      {
        headerName: '主號',
        field: 'mawbNo',
        width: 300,
      },
      {
        headerName: '櫃號',
        field: 'containerNo',
        width: 300,
      },
      {
        headerName: '封條',
        field: 'sealNo',
        width: 150,
      },
      {
        headerName: '櫃型',
        field: 'containerForm',
        width: 150,
      },
      {
        headerName: '快遞/承攬業者',
        field: 'expresssName',
        width: 150,
      },
      {
        headerName: '起運地',
        field: 'loadPortCode',
        width: 300,
      },
      {
        headerName: '件數',
        field: 'pieceNum',
        width: 300,
      },
      {
        headerName: '重量/KG',
        field: 'weight',
        width: 300,
      },
      {
        headerName: '線別',
        field: 'lineNo',
        width: 300,
      },
      {
        headerName: '通關順序',
        field: 'cclSeq',
        width: 300,
      },
      {
        headerName: '船名',
        field: 'vesselName',
        width: 300,
      },
      {
        headerName: '櫃場注記',
        field: 'cynote',
        width: 300,
      },
      {
        headerName: '銷艙比例',
        field: 'mfOffsetNumber',
        width: 300,
      },
    ];
  };
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };

  const handleReset = async () => {
    setMaster(masterDefaultValue);

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 拆櫃預定表查詢
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={3}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*拆櫃日期：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateOneSePickersTyping
                required
                updateData={updateData}
                style={{ maxWidth: 200 }}
                inputDataName="declDate"
                data={master}
                seInterval={31}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>線別：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.lineNo}
                onChange={selectChange(updateData)}
                name="lineNo"
                options={lineNoOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          {!chkCode1Show && (
            <Grid item xs={12} sm="auto">
              <Button
                disabled={formError}
                type="submit"
                variant="contained"
                color="default"
                startIcon={<PrintIcon />}
                onClick={() => setSubmitKey('download')}
              >
                下載Excel
              </Button>
            </Grid>
          )}
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
    </div>
  );
};

export default DevaningPlanQry;
